<template>
    <div>
        <h3>Tenants</h3>
        <p>If you have a list of tenants (e.g. an excel column) you can paste that here</p>
        <p class="margin_bottom">Alternatively add one by one in the next step</p>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100 md-size-50">
                <div class="md-layout md-gutter">
                    <label class="md-layout-item md-size-25 md-form-label">
                        Tenants
                    </label>
                    <div class="md-layout-item" id="ta_wrap">
                        <md-field>
                            <span class="md-helper-text">Copy and paste a list of tenants - one per line</span>
                            <md-textarea v-model="tenants.list" md-autogrow></md-textarea>
                        </md-field>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BuildingTenants',
        props: {
            tenants: { 
                list: String
            }
        }
    }
</script>

<style lang="scss">
    #ta_wrap {
        min-height: 300px;
        max-height: 4500px;
        overflow-y: visible;
        max-height: fit-content;
        textarea{
            overflow-y: visible !important;
            max-height: fit-content;
        }
    }

    .md-steppers-wrapper {
        max-height: 5000px !important;
        overflow-y: visible !important;
        height:auto !important; /* This is what does it - seems somneone is calcing the height at start and setting in style attribute - and not adjusting when content expands */
    }
</style>
